// extracted by mini-css-extract-plugin
export default {"data_input":"DataInput_data_input__sqkQA"};